import { Sparkles, RefreshCw } from "lucide-react";
import { Progress } from "./ui/progress";
import { Button } from "./ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "./ui/alert-dialog";

export const AnalysisProgress = ({ st, onRerunAll }) => {
  const a = st.analysis || {};
  const total = st.balance_check?.transaction_count || a.total || 0;
  const done = st.ai_done_count ?? 0;
  const running = a.status === "running";
  const pct = total ? Math.round((Math.min(done, total) / total) * 100) : 0;
  return (
    <div data-testid="ai-progress" className="rounded-xl border border-slate-200 bg-white p-4">
      <div className="mb-2 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-[15px] font-semibold text-slate-900">
          <Sparkles className={`h-4 w-4 ${running ? "animate-pulse text-amber-600" : "text-slate-500"}`} />
          KI-Erklärungen
        </div>
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button variant="outline" size="sm" disabled={running} data-testid="reanalyze-all-btn" className="gap-1.5">
              <RefreshCw className={`h-3.5 w-3.5 ${running ? "animate-spin" : ""}`} /> Alle neu analysieren
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>Alle Buchungen neu analysieren?</AlertDialogTitle>
              <AlertDialogDescription>
                Alle {total} Buchungen werden erneut von der KI erklärt. Das dauert einige Minuten und verbraucht KI-Guthaben.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Abbrechen</AlertDialogCancel>
              <AlertDialogAction data-testid="confirm-reanalyze-all-btn" onClick={onRerunAll}>Neu analysieren</AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
      <Progress value={pct} className="h-2" data-testid="ai-progress-bar" />
      <div className="mt-2 text-sm text-slate-600" data-testid="ai-progress-text">
        <span className="font-num font-semibold text-slate-900">{done}/{total}</span> analysiert
        {running ? " – läuft im Hintergrund …" : a.status === "done" ? " – fertig" : ""}
        {a.error && <span className="ml-2 text-red-700">({a.error})</span>}
      </div>
    </div>
  );
};
